export default "__VITE_ASSET__Bdq_i1J9__"